import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { ScheduledDate } from './store/schedule-date.model';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import moment from 'moment';
@Injectable({
    providedIn: 'root'
})
export class ScheduledDateService {
    uri = `${environment.apiLocation}/ScheduledDate`;

    constructor(private http: HttpClient, private log: LoggingService) {}
    public get(ShowAll = true): Observable<Array<ScheduledDate>> {
        this.log.verbose({
            type: 'ScheduledDateService:get',
            uri: this.uri
        });
        return (
            this.http
                .get<Array<ScheduledDate>>(this.uri, {
                    params: { ShowAll: ShowAll.toString() }
                })
                // .post<ScheduledDate[]>(this.uri, {ShowAll})
                .pipe(
                    tap(res =>
                        this.log.verbose({
                            type: 'ScheduledDateService:reponse',
                            res
                        })
                    ),
                    map(dates => dates.map(d => this.mapScheduleDates(d)))
                )
        );
    }
    private mapScheduleDates(item: ScheduledDate): ScheduledDate {
        return {
            ...item,
            ScheduledStartDate: moment(item.ScheduledStartDate).isValid()
                ? moment(item.ScheduledStartDate).toDate()
                : null,
            ScheduledEndDate: moment(item.ScheduledEndDate).isValid()
                ? moment(item.ScheduledEndDate).toDate()
                : null
        };
    }
}
